

import React from "react";
import { Component } from "react";
import SearchCompanyProduct from "../../../components/Admin/CompanyProduct/SearchCompanyProduct";
import SearchCompanyGrid from "../../../components/Admin/CompanyProduct/searchcompanygrid";
import { ShowAddCompany,ShowEditCompanyAddress,ShowEditCompanyAVM } from "../../../actions/loading";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import AddCompany from "./add";
import EditCompany from "./editcompany";
import EditAVM from "./avm";
class CompanyProductMain extends Component {
    constructor(props) {
        super(props);   
    }
    // editcompany(cell, row) {
    //     return (
    //         <Link to={{ pathname: "/order-edit", Order: {Id : row.ID, tab:'1'}}}>{cell}</Link>
    //         );
    // }
    action=(cell, row)=> {
        return(<div>
            <Link onClick={() => {this.props.ShowEditCompanyAddress()} }>Edit</Link>
            <Link onClick={() => {this.props.ShowEditCompanyAVM()} }>AVM</Link>
            </div>
                )   
        
       
    }
    orderColumns = [
        {
        dataField: 'id',
        text: 'ID',
        sort: true,
        formatter: this.editcompany,
        hidden: true
        },
        {
        dataField: 'companyname',
        text: 'Name',
        sort: true,
        },
        {
            dataField: 'address',
            text: 'Address',
            sort: true,
        },
        {
            text: 'Action',
            formatter: this.action
        }
    ]
    render() {
        return (
            <>
                <SearchCompanyProduct/>
                <SearchCompanyGrid  OrderColumns={this.orderColumns} />
                <AddCompany />
                <EditCompany/>
                <EditAVM/>
                
            </>
        )
    }
}

var cpf = connect(state => ({
    loading : state.loading,
    searchcompanydata : state.SearchCompany
}),
{ShowAddCompany,ShowEditCompanyAddress,ShowEditCompanyAVM})(CompanyProductMain);

export default cpf;

